var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailInfo",
                  attrs: { noHeader: true },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: { title: "사업장", value: _vm.plantName },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: { title: "자재명", value: _vm.materialName },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: { title: "자재코드", value: _vm.materialCd },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "화학자재일련번호",
                            value: _vm.param.mdmChemMaterialId,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12 col-lg-12" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "유해화학물질(PSM) 정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c(
                            "q-btn",
                            {
                              staticClass: "custom-btn",
                              attrs: {
                                icon: "help",
                                color: "deep-purple-6",
                                "text-color": "white",
                                align: "center",
                                round: "",
                              },
                            },
                            [
                              _c(
                                "q-tooltip",
                                {
                                  attrs: {
                                    anchor: "bottom left",
                                    self: "top left",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "tooltipCustomTop" },
                                    [_vm._v(" (주) ")]
                                  ),
                                  _c("div", { staticClass: "tooltipCustom" }, [
                                    _vm._v(
                                      " ① 유해․위험물질은 제출대상 설비에서 제조 또는 취급하는 모든 화학물질을 기재합니다."
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ② 증기압은 상온에서의 증기압을 말합니다."
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ③ 부식성 유무는 있으면 ○, 없으면 ×로 표시합니다."
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ④ 이상반응 여부는 그 물질과 이상반응을 일으키는 물질과 그 조건(금수성 등)을 표시하고 필요시 별도로 작성합니다."
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ⑤ 노출기준에는 시간가중평균노출기준(TWA)을 기재합니다."
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ⑥ 독성치에는 LD50(경구, 쥐), LD50(경피, 쥐 또는 토끼) 또는 LC50(흡입, 4시간 쥐)을 기재합니다. "
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.mappingType,
                                  label: "저장",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveHazard,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "%",
                            editable: _vm.editable,
                            label: "폭발한계상한(%)",
                            name: "explUpLimit",
                          },
                          model: {
                            value: _vm.data.explUpLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "explUpLimit", $$v)
                            },
                            expression: "data.explUpLimit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "%",
                            editable: _vm.editable,
                            label: "폭발한계하한(%)",
                            name: "explLowLimit",
                          },
                          model: {
                            value: _vm.data.explLowLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "explLowLimit", $$v)
                            },
                            expression: "data.explLowLimit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "℃",
                            editable: _vm.editable,
                            label: "인화점(℃)",
                            name: "flashingPoint",
                          },
                          model: {
                            value: _vm.data.flashingPoint,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "flashingPoint", $$v)
                            },
                            expression: "data.flashingPoint",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "℃",
                            editable: _vm.editable,
                            label: "발화점(℃)",
                            name: "ignitionPoint",
                          },
                          model: {
                            value: _vm.data.ignitionPoint,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "ignitionPoint", $$v)
                            },
                            expression: "data.ignitionPoint",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 3,
                            label: "노출기준",
                            name: "exposureLimit",
                          },
                          model: {
                            value: _vm.data.exposureLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "exposureLimit", $$v)
                            },
                            expression: "data.exposureLimit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 3,
                            label: "독성치",
                            name: "toxicValue",
                          },
                          model: {
                            value: _vm.data.toxicValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "toxicValue", $$v)
                            },
                            expression: "data.toxicValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "mmHg",
                            editable: _vm.editable,
                            label: "증기압(20℃,mmHg)",
                            name: "vaporPressure",
                          },
                          model: {
                            value: _vm.data.vaporPressure,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "vaporPressure", $$v)
                            },
                            expression: "data.vaporPressure",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "Nm/kg",
                            editable: _vm.editable,
                            label: "일일취급량(kg)",
                            name: "dailyUsage",
                          },
                          model: {
                            value: _vm.data.dailyUsage,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "dailyUsage", $$v)
                            },
                            expression: "data.dailyUsage",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "Nm/kg",
                            editable: _vm.editable,
                            label: "저장량(kg)",
                            name: "stockage",
                          },
                          model: {
                            value: _vm.data.stockage,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "stockage", $$v)
                            },
                            expression: "data.stockage",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-dept", {
                          attrs: {
                            type: "edit",
                            label: "관리부서",
                            name: "deptCd",
                          },
                          model: {
                            value: _vm.data.deptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "deptCd", $$v)
                            },
                            expression: "data.deptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 3,
                            label: "이상반응유무",
                            name: "extraReaction",
                          },
                          model: {
                            value: _vm.data.extraReaction,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "extraReaction", $$v)
                            },
                            expression: "data.extraReaction",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            counter: true,
                            maxlength: 500,
                            editable: _vm.editable,
                            rows: 3,
                            label: "부식성유무",
                            name: "corrosivenessFlag",
                          },
                          model: {
                            value: _vm.data.corrosivenessFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "corrosivenessFlag", $$v)
                            },
                            expression: "data.corrosivenessFlag",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }